import React from "react";
import StatusBubble from "../Components/StatusBubble";

const WorkOnTaskBox = ({ activeTask }) => {
  let boxStyles = [
    "px-5 py-4 rounded-xl mb-6 border-2 border-slate-100 dark:border-transparent bg-white dark:bg-primary-dark font-semibold shadow-lg cursor-pointer ",
  ];
  
  return (
    <div className={boxStyles.join(" ")}>
      {activeTask ? (
        <div className="flex flex-col items-center my-[1px]">
          <h1 className="mb-2 text-lg w-full">{activeTask._Title}</h1>
          <div className=" w-full lg:flex justify-between transition-none">
            <div className="mr-2 transition-none">
              <p>Started on:</p>
              <p className="text-gray-400">01/12/2021</p>
            </div>
            <div className="transition-none">
              <p>Due to:</p>
              <p className="text-gray-400">01/12/2021</p>
            </div>
          </div>
          <div className="w-fit mt-3">
            <StatusBubble status={activeTask._Status} />
          </div>
        </div>
      ) : (
        <div className="my-[1px]">
          {/* No task selected */}
          <div className="my-10">
            <div class="bg-slate-300 dark:bg-white transition-none m-auto h-1 w-12 rounded-full"></div>
            <div class="bg-slate-300 dark:bg-white transition-none m-auto h-1 w-12 mt-[-3px] rounded-full rotate-90"></div>
          </div>
          <p className="text-center text-slate-400 dark:text-white">
            Select a task
          </p>
        </div>
      )}
    </div>
  );
};

export default WorkOnTaskBox;
